import React from 'react';
import { useSelector } from 'react-redux';
import products from '../css/products.module.css';
import ProductCard from '../components/ProductCard';
import { getFilteredProductsWithPagination } from '../selectors';
import Pagination from '@material-ui/lab/Pagination';
import useDidMountEffect from '../hooks/useDidMountEffect';

const ProductsGrid = (props) => {
    const [page, setPage] = React.useState(1);
    const liquors = useSelector((state) =>
        getFilteredProductsWithPagination(state)
    );
    useDidMountEffect(() => {
        setPage(1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [liquors.length]);
    return (
        <div>
            <Pagination
                count={liquors.length}
                color="primary"
                onChange={(event, value) => setPage(value)}
                page={page}
                style={{ marginBottom: '1rem' }}
            />
            {liquors[page - 1] && (
                <main className={products.grid}>
                    {liquors[page - 1].map((item) => {
                        return <ProductCard product={item} key={item.sku} />;
                    })}
                    {!liquors.length && <p>There's nothing here</p>}
                </main>
            )}
            <Pagination
                count={liquors.length}
                color="primary"
                onChange={(event, value) => setPage(value)}
                page={page}
                style={{ marginTop: '1rem' }}
            />
        </div>
    );
};

export default ProductsGrid;
